const STF_BASE_URL = import.meta.env.DEV
  ? "/stf"
  : import.meta.env.VITE_STF_URL;

/** img_kind 定数（iOS URLGenerator 準拠） */
const IMG_KIND = {
  AVATAR: "1",
  PUBLIC_IMAGE: "2",
  FLEA_MARKET: "6",
  AGORA_SCREENSHOT: "8",
} as const;

/**
 * STF サーバーから画像を取得する URL を生成する（token 不要版）。
 * Next.js 版と同じ load_img_for_utage_web API を使用し、
 * URL に token を含めないことでブラウザキャッシュを有効にする。
 */
const buildImageUrl = (imgId: string, imgKind: string): string => {
  return `${STF_BASE_URL}/api=load_img_for_utage_web&img_id=${encodeURIComponent(imgId)}&img_kind=${imgKind}`;
};

/** アバター / サムネイル画像の URL を生成 */
export const getAvatarUrl = (imgId: string | null): string | null => {
  if (!imgId) return null;
  return buildImageUrl(imgId, IMG_KIND.AVATAR);
};

/** 公開画像（プロフィール写真一覧）の URL を生成 */
export const getPublicImageUrl = (imgId: string): string => {
  return buildImageUrl(imgId, IMG_KIND.PUBLIC_IMAGE);
};

/** ギャラリーの購入済み画像・動画サムネイル URL */
export const getGalleryImageUrl = (fileId: string): string => {
  return buildImageUrl(fileId, IMG_KIND.AVATAR);
};

/** ギャラリーの購入済み動画本体 URL（再生用） */
export const getGalleryVideoUrl = (fileId: string): string => {
  return `${STF_BASE_URL}/api=load_file_for_utage_web&file_id=${encodeURIComponent(fileId)}`;
};

/** フリマ商品画像の URL を生成 */
export const getFleaMarketImageUrl = (imgId: string): string => {
  return buildImageUrl(imgId, IMG_KIND.FLEA_MARKET);
};

/** ライブ配信サムネイル（Agora スクリーンショット）の URL を生成 */
export const getLiveThumbnailUrl = (imgId: string): string => {
  return buildImageUrl(imgId, IMG_KIND.AGORA_SCREENSHOT);
};

/** ライブ配信録画動画の URL を生成（token 必須） */
export const getLiveRecordingUrl = (
  recordingId: string,
  token: string,
): string => {
  return `${STF_BASE_URL}/api=load_live_recording&token=${encodeURIComponent(token)}&file_id=${encodeURIComponent(recordingId)}`;
};
